import { authService } from "~/modules/Auth/authService";
import { useAuthStore } from "~/modules/Auth/authStore";

import { API } from "./generated-api";

export const requestManager = {
  controller: new AbortController(),

  abortAll() {
    this.controller.abort();
    this.controller = new AbortController();
  },
};


export const ApiClient = new API({
  baseURL: import.meta.env.MODE === "test" ? "http://localhost:3000" : import.meta.env.VITE_APP_URL,
  secure: true,
  withCredentials: true,
});


ApiClient.instance.interceptors.response.use(
  (response) => response,
  async (error) => {

    const isAuthEndpoint =
      error.config?.url?.includes("/auth/") ||
      error.config?.url?.includes("/settings/global")||
      error.config?.url?.includes("/env/frontend") ||
      error.config?.url?.includes("/current-user");
     
    // 🚫 Never retry refresh calls
    if (error.config?.url?.includes("/auth/refresh")) {
      authService.logout();
      return Promise.reject(error);
    }



    if (error.config?.url?.includes("/logout")) {
      return Promise.reject(error);
    }


    /*
    if (
      error.response?.status === 401 &&
      !error.config._retry &&
      useAuthStore.getState().isLoggedIn
    ) {
      error.config._retry = true;
      try {
        authService.logout();
        await authService.refreshToken();
        return ApiClient.instance(error.config);
      } catch {
        requestManager.abortAll();
        return Promise.reject(error);
      }
    }
   */
   
    if (
      error.response?.status === 401 &&
      !error.config?._retry &&
      !isAuthEndpoint
    ) {
      error.config._retry = true;
       
      try {
        await authService.refreshToken();
        return ApiClient.instance(error.config);
      } catch {
        requestManager.abortAll();
        
        return Promise.reject(error);
      }
    }



    return Promise.reject(error);
  },
);
